/**
 * File utilities for web (stub implementation)
 * Web uses native HTML file input, so these functions are not needed
 *
 */

import { FileWithUri } from './fileUtils'

/**
 * Not implemented for web - web uses HTML file input
 */
export const pickImageFromLibrary = async (): Promise<FileWithUri | null> => {
  console.warn('[FileUpload] pickImageFromLibrary called on web - not implemented')
  return null
}

/**
 * Not implemented for web - web uses HTML file input
 */
export const pickDocumentFromLibrary = async (_acceptedMimeTypes?: string[]): Promise<FileWithUri | null> => {
  console.warn('[FileUpload] pickDocumentFromLibrary called on web - not implemented')
  return null
}
